export enum Cookie {
  Product = 'product',
  VerificationCodeSend = 'verification_code_send',
}
